import { Link } from 'react-router-dom';
import { CampaignListRow } from './columns';
import { getCampaignPath } from './paths';

type CampaignLinkProps = {
  row: Pick<
    CampaignListRow,
    | 'campaignName'
    | 'approvalStatus'
    | 'campaignId'
    | 'reportType'
    | 'lciVersion'
    | 'reportId'
    | 'campaignType'
    | 'partner'
  >;
  reportGroup?: string;
  partnerName?: string;
};

export const CampaignLink = (props: CampaignLinkProps) => {
  const campaignName = props.row.campaignName;

  if (props.row.approvalStatus !== 'approved') {
    return (
      <span
        title={campaignName}
        style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {campaignName}
      </span>
    );
  }

  const path = getCampaignPath(
    props.row.campaignId,
    props.row.campaignType,
    props.row.reportType,
    props.row.lciVersion,
    props.row.reportId,
    props.partnerName ?? props.row.partner,
    props.reportGroup
  );

  const builtPath = [path.pathname, path.search].join('');

  return (
    <Link
      to={builtPath}
      style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
      title={campaignName}
    >
      {campaignName}
    </Link>
  );
};
